import { CardContent, CardHeader, Stack } from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import Table from "../../../components/Table";
import { useEffect, useState } from "react";
import { FileUpload, FilterAlt } from "@mui/icons-material";
import { deleteData, fetchData } from "../../../services";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index";
import { useLoading } from "../../../components/Loading";
import { useSnackbar } from "../../../context/popup";
import BulkUpload from "../../../components/blukUplod";
import PrevInsurerFilterDialog from './components/PrevInsurerFilterDialog.js';

const PreviousInsurerList = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();

  const currentPage = useSelector(
    (state) => state?.previousInsurerStore?.currentPage
  );
  const rowsPerPage = useSelector(
    (state) => state?.previousInsurerStore?.rowsPerPage
  );
  const totalPages = useSelector(
    (state) => state?.previousInsurerStore?.totalPages
  );

  const [isRefresh, setIsRefresh] = useState(false);
  const [openUploadFileDialog, setOpenUploadFileDialog] = useState(false);
  const [search, setSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [previousInsurerData, setpreviousInsurerData] = useState([]);
  const [filterData, setFilterData] = useState({
    isActive: "",
    businessType: "",
  });

  useEffect(() => {
    fetchDistrictList();
  }, [isRefresh, currentPage, rowsPerPage, search]);

  //List API
  const fetchDistrictList = async () => {
    setCircleLoading(true);
    try {
      let url = `/reference/insurer/previous-insurer?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`
      
      if(filterData.isActive !== "" && filterData.isActive !== null && filterData.isActive !== undefined) {
          url += `&isActive=${filterData.isActive}`;
      }
      if(filterData.businessType !== "" && filterData.businessType !== null && filterData.businessType !== undefined) {
          url += `&businessType=${filterData.businessType}`;
      }
      const response = await fetchData(url);

      if (response?.success) {
        setpreviousInsurerData(response?.data?.items);
        dispatch(setTotalPages(response?.data?.totalPages));
      }
    } catch (error) {
      console.error("Error Fetching Data",error)
      showSnackbar(error?.response?.data?.message || error?.message, "error");
    } finally {
      setCircleLoading(false);
    }
  };

  const handleDelete = async (row) => {
    setCircleLoading(true);
    try {
      const response = await deleteData(`/reference/insurer/previous-insurer/delete`, {
        ids: [row?.id],
      });
      const responseMessage = response?.message;
      setIsRefresh(!isRefresh);
      if (response?.success) {
        showSnackbar(responseMessage, "success");
      } else {
        showSnackbar(responseMessage, "success");
      }
    } catch (error) {
      showSnackbar(error?.response?.data?.message, "error");
    } finally {
      setCircleLoading(false);
    }
  };

  //Table Mapping
  const previousInsurerListTable = {
    columns: [
      {
        key: "sno",
        label: "S.No.",
        renderCell: (row) => row.sno,
      },
      {
        key: "name",
        label: "Previous Insurer Name",
        renderCell: (row) => row.name,
      },
      {
        key: "code",
        label: "Code",
        renderCell: (row) => row.code,
      },
      {
        key: "gInsurerName",
        label: "Insurer",
        renderCell: (row) => row.gInsurerName,
      },
      {
        key: "createdAt",
        label: "Created At",
        renderCell: (row) => row.createdAt,
      },
      {
        key: "isActive",
        label: "Status",
        renderCell: (row) => (
          <span>
            {row.isActive ? (
              <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
            ) : (
              <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
            )}
          </span>
        ),
      },
    ],
    rows: previousInsurerData?.map((Pre, index) => ({
      id: Pre?.id,
      sno: index + 1,
      name: Pre?.prevInsurerName || "",
      code: Pre?.code || "",
      gInsurerName: Pre?.gInsurerName || "",
      isActive: Pre?.isActive,
      createdAt: new Date(Pre?.createdAt).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
    })),
  };

  const handleAddNewPreviousInsurer = () => {
    navigate(`/insurer-master/insurer-previous-insurer/add-previous-insurer`);
  };

  const actions = {
    edit: true,
    view: true,
    delete: true,

    onEdit: (row) => {
      navigate(
        `/insurer-master/insurer-previous-insurer/add-previous-insurer?pageType=edit&id=${row.id}`
      );
    },
    onView: (row) => {
      navigate(
        `/insurer-master/insurer-previous-insurer/add-previous-insurer?pageType=view&id=${row.id}`
      );
    },
    onDelete: (row) => handleDelete(row),
  };

  const handlePaginationChange = (page) => {
    dispatch(setCurrentPage(page));
  };

  const handleRowsPerPageChange = (rowsPerPage) => {
    dispatch(setRowsPerPage(rowsPerPage));
    dispatch(setCurrentPage(1));
  };
  const handleSearch = (value) => {
    setSearch(value);
  };
  return (
    <DashboardLayout>
      <CardHeader
        title={
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Stack direction="column" spacing={0}>
              <MaterialTypography variant="h5" fontWeight="medium">
                Previous Insurer List
              </MaterialTypography>
              <MaterialTypography variant="caption" color="text">
                List of Previous Insurer around the world.
              </MaterialTypography>
            </Stack>
            <Stack direction="row" spacing={1}>
              <MaterialButton
              variant="gradient"
              color="dark"
              size="small"
              startIcon={<FilterAlt/>}
              onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                  Filter
              </MaterialButton>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<FileUpload />}
                onClick={() => setOpenUploadFileDialog(true)}
              >
                Bulk Upload
              </MaterialButton>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleAddNewPreviousInsurer()}
              >
                Previous Insurer
              </MaterialButton>
            </Stack>
          </Stack>
        }
      />
      <CardContent>
        <Table
          columns={previousInsurerListTable?.columns}
          data={previousInsurerListTable?.rows}
          actions={actions}
          pagination={{
            totalPages,
            currentPage,
            onPageChange: (page) => handlePaginationChange(page),
            rowsPerPage,
            onRowsPerPageChange: (rowsPerPage) =>
              handleRowsPerPageChange(rowsPerPage),
            rowsPerPageOptions: [5, 10, 15, 20],
          }}
          getRowKey={(row) => row.id}
          className="custom-table"
          noDataLabel="No Previous Insurer found"
          handleSearch={handleSearch}
        />
      </CardContent>
      <BulkUpload
        open={openUploadFileDialog}
        setOpen={setOpenUploadFileDialog}
        endPoint="/reference/motor/insurer/bulkUpload/insurer-PreviousInsurer"
        fetchList={fetchDistrictList}
      />      
      <PrevInsurerFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);   // close popup
            fetchDistrictList();  // call API after filter applied
        }}
        />
    </DashboardLayout>
  );
};

export default PreviousInsurerList;
